import React, { useEffect, useState } from 'react'
import classes from './comp.module.css'
import Cookies from 'js-cookie'
import { BASE_URL } from '../../../Apis/BaseUrl'
import CompCard from './CompCard'
import axios from 'axios'
import AddObject from '../../Apperance/Modal/AddObject'
import NewPagination from '../../../Component/NewPagination/NewPagination'
import ToasterUpdate from '../../../Component/Toaster/ToasterUpdate'
import { toast } from 'react-toastify'
import UpdateObject from '../../Apperance/Modal/UpdateObject'

const Objects = () => {

    const [show, setShow] = useState(false)

    const [data, setData] = useState([])
    const [page, setPage] = useState(1)
    const [pageInfo, setPageInfo] = useState({})
    const [limit, setLimit] = useState(10)
    const [loading, setLoading] = useState(false)
    const [currentObject, setCurrentObject] = useState({})
    const [show2,setShow2] = useState(false)

    let profileTokenJson = Cookies.get("v&b_token");
    let profileToken = JSON.parse(profileTokenJson);
    let token = profileToken.token;

    const getData = async () => {

        let register = `${BASE_URL}/visualizer/object?limit=${limit}&page=${page}`

        let res = await axios.get(register, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        })
        setData(res.data.docs)
    }

    useEffect(() => {
        getData()
    }, [page, limit])

    
useEffect(() => {
    setPage(1)
}, [limit]
)

    
    const paginationProps = {
        setPage,
        pageInfo, setLimit
    }


    function handleUpdate() {
        setCurrentObject(this)
        setShow2(true)
    }

    async function handleDelete(id) {
        const myToast = toast.loading('Please Wait...')
        let register = `${BASE_URL}/visualizer/object/${id}/remove`

        let res = await axios.delete(register, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        })

        if (!res.data.success) {
            ToasterUpdate(myToast,res.data.message,'error')
            return ;
        }

        ToasterUpdate(myToast,res.data.message,'success')
        getData()
    }

    return (
        <React.Fragment>

            <div className={classes.container}>
                <div className='d-flex justify-content-between align-items-center mt-3'>
                    <h6 style={{ color: "#AE0000" }}>Objects</h6>
                    <button onClick={() => setShow(true)} className='px-3 py-2 rounded-1 border-0' style={{ backgroundColor: "#AE0000", color: "white" }}>Add Object</button>
                </div>
                {loading ? 'Loading' :
                    data.length > 0 ?
                        data?.map((item) => (
                            <CompCard handleUpdate={handleUpdate.bind(item)} handleDelete={()=>handleDelete(item._id)} label={'name'} data={item} func={getData} />
                        )) : 'No Data Found!'
                }

<NewPagination {...paginationProps} />

            </div>

            {show && <AddObject closeModal={() => setShow(false)} data={getData} isOpen={show} />}
            {show2 && <UpdateObject data={currentObject} closeModal={() => setShow2(false)} getData={getData} isOpen={show2} />}
        </React.Fragment>
    )
}

export default Objects